import LocalStorage from '../storage/LocalStorage';
import getSessionId from './getSessionId';

export const isAuthenticated = (): boolean => Boolean(
	getSessionId() || LocalStorage.get('is_local')
);

// export const isAuthenticated = (): boolean => Boolean(
// 	getSessionId()
// );

export default isAuthenticated;


// WEBPACK FOOTER //
// ./src/utils/auth/isAuthenticated.js